import axios from 'axios'

const SET_SUPPLIERS = 'SET_SUPPLIERS'
const SET_TIMESTAMP = 'SET_TIMESTAMP'

/**
 * Vuex state for supplier module
 * @type {Object}
 */
const state = {
    suppliers: [],
}

/**
 * Vuex mutations for supplier module
 * @type {Object}
 */
const mutations = {
    [SET_SUPPLIERS]: (state, payload) => {
        state.suppliers = payload
    },

    [SET_TIMESTAMP]: (state, payload) => {
      state.timestamp = payload
    }
}

/**
 * Vuex actions for supplier module
 * @type {Object}
 */
const actions = {
    async fetchSuppliers({ dispatch, commit }) {
        dispatch('wait/start', 'supplier.fetchSuppliers', { root: true })

        const { data } = await axios.get('/api/suppliers')
        dispatch('setSuppliers', data.data)
        commit(SET_TIMESTAMP, data.timestamp)

        dispatch('wait/end', 'supplier.fetchSuppliers', { root: true })
        return data
    },

    async addFavorite({ dispatch }, { uuid }) {
        const { data } = await axios.post(`/api/favorites/${uuid}`)
        await dispatch('fetchSuppliers')
        return data
    },

    async removeFavorite({ dispatch }, { uuid }) {
        const { data } = await axios.delete(`/api/favorites/${uuid}`)
        await dispatch('fetchSuppliers')
        return data
    },

    setSuppliers({ commit }, suppliers) {
        commit(SET_SUPPLIERS, suppliers)
    }
}

/**
 * Vuex getters for supplier module
 * @type {Object}
 */
const getters = {
    suppliers: state => state.suppliers,

    steelSuppliers: state => (
        state.suppliers.filter(e => e.is_steel_supplier)
    ),

    favorites: state => (
        state.suppliers.filter(e => e.is_favorite)
    ),

    suppliers_timestamp: state => state.timestamp
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
